import { PButtonPure, PText, PFlex, PFlexItem } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import ApplicationInformation from '../../../utils/Applications'
import Actions from '../Actions/Actions'
import Modules from '../Modules/Modules'

import { TEXTS } from '../../../config/texts'
import { PortalContext } from '../../../utils/PortalContext'

import PAGRating from '../../../Types'
import styles from './subapp.module.css'

type Props = {
  subApp: PAGRating.SubApp
  app: PAGRating.App
}

const SubApp = ({ subApp, app }: Props) => {
  const [openSubCollapse, setOpenSubCollapse] = React.useState(false)

  const { openDrawer, drawerData, setDrawerData, setOpenDrawer, setDrawerContent } = React.useContext(PortalContext)

  const openSubCollapsible = () => {
    if (subApp.modules) {
      setOpenSubCollapse(!openSubCollapse)
    }
  }

  const openDetailsInDrawerSubApp = (event: React.MouseEvent) => {
    event.stopPropagation()
    setDrawerData(subApp)
    setOpenDrawer(true)
    setDrawerContent('DetailsApp')
    setOpenSubCollapse(true)
  }

  const ModulesList = subApp.modules?.map((module: PAGRating.Module) => {
    if (module.active) {
      module = {
        ...module,
        appInformation: ApplicationInformation({
          app: app,
          subApp: subApp,
          module: module
        })
      }
      return <Modules module={module} key={module.moduleId} />
    }
  })
  subApp = {
    ...subApp,
    appInformation: ApplicationInformation({
      app: app,
      subApp: subApp
    })
  }

  return (
    <div
      className={clsx({
        [styles.openSub]: openSubCollapse
      })}
    >
      <PFlex
        className={clsx(
          styles.subApp,
          {
            [styles.hoverable]: subApp.modules
          },
          {
            [styles.active]: openDrawer && drawerData.appInformation?.configId === subApp.configId
          }
        )}
        onClick={openSubCollapsible}
        alignContent='center'
      >
        <PFlexItem>
          {subApp.modules && subApp.modules?.length !== 0 && (
            <PButtonPure hideLabel icon='arrow-head-down' className={styles.dropIconModule}>
              {TEXTS.SUB_APP_OPEN}
            </PButtonPure>
          )}
        </PFlexItem>
        <PFlexItem flex='auto' className={styles.hoverable} onClick={openDetailsInDrawerSubApp}>
          <PText className={styles.appTitle}>{subApp.subAppDescription}</PText>
          <PText color='neutral-contrast-medium' className={styles.appTitle}>
            {subApp.appId === 'APP-' ? '' : subApp.appId}
          </PText>
          {subApp.test && (
            <PText color='neutral-contrast-medium' size='x-small' className={styles.appTitle}>
              {TEXTS.SUB_APP_TEST_BADGE}
            </PText>
          )}
        </PFlexItem>
        <Actions className={styles.actions} appData={subApp} />
      </PFlex>
      <div className={styles.dropSubContent}>{subApp.modules && ModulesList}</div>
    </div>
  )
}

export default SubApp
